<template>
  <div class="container-fluid mb-1 fixedmenuheader">
    <!-- <div v-if="userType === 'AD'">
      <menu-type-admin></menu-type-admin>
    </div>
    <div v-else-if="userType === 'CA'">
      <menu-type-admin></menu-type-admin>
    </div>
    <div v-else-if="userType === 'BO'">
      <menu-type-back-office></menu-type-back-office>
    </div>
    <div v-else-if="userType === 'SR'">
      <menu-type-sales-agent></menu-type-sales-agent>
    </div> -->
    <div>
      <menu-type-admin></menu-type-admin>
    </div>
  </div>
</template>
<script>
import MenuTypeAdmin from './MenuTypeAdmin.vue'
import MenuTypeBackOffice from './MenuTypeBackOffice.vue'
import MenuTypeSalesAgent from './MenuTypeSalesAgent.vue'

export default {
  name: 'top-menu',
  data () {
    return {
      userType: this.$session.get('user_role')
    }
  },
  mounted: function () {
    this.hasSessionActive()
  },
  methods: {
    hasSessionActive () {
      if (this.userType == null || this.$session.get('user_id') == null) {
        this.$router.replace(this.$route.login || '/')
      }
    }
  },
  components: {
    MenuTypeAdmin,
    MenuTypeBackOffice,
    MenuTypeSalesAgent
  }
}
</script>
<style scoped>
.fixedmenuheader {
  width: 100%;
  right: 0px;
  position: fixed;
  z-index: 5;
}
@media screen and (min-width: 769px) and(max-width: 1100px) {
  .fixedmenuheader {
    margin-top: 125px !important;
    padding: 0px 64px 0px 15px !important;
    background-color: white;
  }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
  .fixedmenuheader {
    margin-top: 120px !important;
    padding: 0px 64px 0px 15px !important;
    background-color: white;
  }
}
@media screen and (min-width: 400px) and (max-width: 600px) {
  .fixedmenuheader {
    margin-top: 135px !important;
    padding: 0px 64px 0px 15px !important;
    background-color: white;
  }
}
@media screen and (min-width: 600px) and (max-width: 768px) {
  .fixedmenuheader {
    margin-top: 78px !important;
    padding: 0px 64px 0px 15px;
    background-color: white;
  }
}
</style>
